import logger from '../debug';
import { ContextStore } from '../stores';
import { createListener } from './listener';
import { ListenerOptions, ListenerTrackerContext } from './types';

export const initListener = (trackerProxy: ListenerTrackerContext, contextStore: ContextStore, options: ListenerOptions = {}) => {
  const { elementId } = options;
  const root = elementId ? document.getElementById(elementId) : document;

  if (root) {
    const listen = createListener(trackerProxy, contextStore, options) as (event: Event) => Promise<void>; // cast needed because typescript doesn't understand document and element clickevent are same

    root.addEventListener('click', listen);
    logger.debug(`listener added to ${elementId || 'document'}`);

    return () => {
      root.removeEventListener('click', listen);
      logger.debug(`listener removed from ${elementId || 'document'}`);
    };
  }

  logger.warn(`Unable to add listener: element with id '${elementId}' was not found`);
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return () => {};
};

export { getAttributeData } from './get-event-data';
export { default as toAttributeData } from './to-attribute-data';
